(function () {
  var cfg = window.__arImgProtect || {};
  var wmUrl = cfg.watermarkUrl;
  var opacity = typeof cfg.opacity === 'number' ? cfg.opacity : 0.13;

  function isImg(el) {
    return !!el && el.tagName === 'IMG';
  }

  document.addEventListener('contextmenu', function (e) {
    if (isImg(e.target)) e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (isImg(e.target)) e.preventDefault();
  });

  var style = document.createElement('style');
  style.textContent = 'img{-webkit-touch-callout:none;}';
  document.head.appendChild(style);

  if (!wmUrl) return;

  var SKIP_SELECTOR = [
    'header', 'footer', '.site-header', '.site-footer',
    '[class*="header" i]', '[class*="footer" i]', '[class*="logo" i]',
    '[class*="icon" i]', '.ar-no-wm'
  ].join(',');

  var MATCH_SELECTOR = [
    'a[href*="/products/"] img',
    '[itemprop="image"]',
    '[class*="product-img" i] img',
    '[class*="product-image" i] img',
    '[class*="product-media" i] img',
    '[class*="product-photo" i] img',
    '[class*="product-gallery" i] img',
    '[class*="t4s-product" i] img'
  ].join(',');

  function rectsClose(a, b) {
    if (!a.width || !a.height || !b.width || !b.height) return false;
    return (b.width / a.width) < 1.6 && (b.height / a.height) < 1.6;
  }

  function findContainer(img) {
    var el = img.parentElement;
    var imgRect = img.getBoundingClientRect();
    var depth = 0;
    while (el && depth < 4) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'static' && rectsClose(imgRect, el.getBoundingClientRect())) {
        return el;
      }
      el = el.parentElement;
      depth++;
    }
    return null;
  }

  function watermark(img) {
    if (img.dataset.arWm === '1') return;
    if (img.closest(SKIP_SELECTOR)) return;

    var container = findContainer(img);

    if (!container) {
      container = document.createElement('span');
      container.style.cssText = 'position:relative;display:inline-block;max-width:100%;line-height:0;';
      img.parentNode.insertBefore(container, img);
      container.appendChild(img);
    }

    var overlay = document.createElement('span');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.className = 'ar-wm-overlay';
    overlay.style.cssText =
      'position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none;' +
      'background-image:url(' + wmUrl + ');background-repeat:repeat;' +
      'background-size:130px auto;opacity:' + opacity + ';z-index:2;';
    container.appendChild(overlay);
    img.dataset.arWm = '1';
  }

  function scan() {
    document.querySelectorAll(MATCH_SELECTOR).forEach(watermark);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(scan, 50);
  });
})();
